export const defaultGroups = [
  "Risk migration",
  "Process Enhancements",
  "Relationship Management",
  "Contract Benefits",
];